import React, { useState, useRef } from 'react';
import './Login.css';
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Link } from 'react-router-dom';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { login } from '../../redux/actions/auth';
import "bootstrap/dist/css/bootstrap.min.css";
import { Fragment } from 'react';
import Nav from '../Nav/nav'

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Kolom tidak boleh kosong!
      </div>
    );
  }
};

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn, user } = useSelector(state => state.auth);
  console.log(user, 'apa')
  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch(login(email, password))
        .then(() => {
          props.history.push("/userpage");
          // window.location();
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  console.log(isLoggedIn, 'test')
  if (isLoggedIn) {
    return <Redirect to="/userpage" />;
  }

  return (
    <Fragment>
      <Nav />
      <div className="login-background">
        <div className="login-container">
          <div className="wrapper">
            <div className="title">Masuk</div>

            <Form onSubmit={handleLogin} ref={form}>
              <div className="row">
                <label htmlFor="email">Alamat e-mail</label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Masukkan alamat e-mail"
                  name="email"
                  value={email}
                  onChange={onChangeEmail}

                  required
                />
              </div>

              <div className="row">
                <label htmlFor="password">Kata Sandi</label>
                <Input
                  type="password"
                  placeholder="Masukkan kata sandi"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={onChangePassword}
                  validations={[required]}
                />
              </div>

              <div className="pass"><Link to="/forgetpassword">Lupa kata sandi?</Link></div>

              <div className="row button">
                <button className="btn-login-page" disabled={loading}>
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span>Masuk</span>
                </button>
              </div>

              {message && (
                <div className="alert alert-danger" role="alert">
                  {message}</div>
              )}

              <CheckButton style={{ display: "none" }} ref={checkBtn} />
              <div className="signup-link">
                Belum mempunyai akun? <Link to="/daftar">Daftar sekarang</Link>
              </div>

            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;